class VenueAPI {
  constructor() {
    this.baseURI = drupalSettings.path.baseUrl + drupalSettings.path.currentLanguage + '/jsonapi/node/venue';
  }

  defineIncludes(includes) {
    this.includes = includes;
    this.querystring_includes = '&include=' + includes;
  }

  defineFields(fieldArray) {
    this.definedFields = fieldArray;
    this.querystring_fields = Object.keys(fieldArray).map(key => 'fields['+key+']' + '=' + fieldArray[key]).join('&');
  }

  setPaging(paging) {
    this.paging = paging;
    this.querystring_paging = '&page[limit]='+paging;
  }

  setFilters(queryString) {
    this.querystring_filter = queryString;
  }

  setOrder() {
    this.querystring_order = '&sort=title'
  }

  callApi() {
    if (typeof this.querystring_paging === 'undefined') {
      this.querystring_paging = '';
    }

    this.setOrder();

    return fetch(this.baseURI + '?' + this.querystring_fields + this.querystring_includes + this.querystring_paging + this.querystring_filter + this.querystring_order, {credentials: "same-origin", method: 'GET'})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((results) => {return results})
      .catch(() => {console.log('There was an errror');});
  }

  callUrl(url) {
    return fetch(url, {credentials: "same-origin", method: 'GET'})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((results) => {return results})
      .catch(() => {console.log('There was an errror');});
  }
}

export default VenueAPI;
